import { Component } from "react";
import { graphql } from "gatsby";
import styles from "./restaurant-block.module.less";
import UtilityArea from "components/block-elements/utility-area/utility-area";
import SiteConfig from "components/stores/site-configuration-store";
import FoodNumber from "components/block-elements/food-number/food-number";
import { extract, isArray, createDate, ParkFoodService } from "@parksandresorts/core";
import { AnimatePresence } from "framer-motion";
import { motion } from "polyfill/motion-polyfill/motion-polyfill";

export default class RestaurantBlock extends Component {
  constructor(props) {
    super(props);
    this.title = extract(props, "title");
    this.preamble = extract(props, "preamble.preamble");
    this.description = extract(props, "description.childMarkdownRemark.html");
    this.backgroundMode = extract(props, "backgroundMode");
    this.id = extract(props, "id");
    this.mapLinkInternal = extract(props, "mapLink.internalLink.slug");
    this.mapLink = this.mapLinkInternal ? this.mapLinkInternal : extract(props, "mapLink.externalUrl");
    this.mapLinkInNewTab = extract(props, "mapLink.openInNewTab");
    //this.closedLabel = SiteConfigurationStore.getLabel('CLOSED');
    this.externalPejLink = extract(props, "externalPejLink");
    this.utilityAreaLabel = SiteConfig.getLabel("RESTAURANT_ORDER_ONLINE", "Beställ online");
    this.foodOdersLabel = SiteConfig.getLabel("RESTAURANT_FOOD_ORDERS", "Matbeställningar");
    this.readyToCollectLabel = SiteConfig.getLabel("RESTAURANT_READY_TO_COLLECT", "Färdiga att hämta");
    this.rightNowPreparedLabel = SiteConfig.getLabel("RESTAURANT_RIGHT_NOW_PREPARED", "Just nu tillagas");
    this.fetchingOrdersLabel = SiteConfig.getLabel("RESTAURANT_FETCHING_ORDERS_FROM_API", "Hämtar beställningar...");
    this.noOrdersToShowLabel = SiteConfig.getLabel("RESTAURANT_NO_ORDERS_TO_SHOW", "Inga beställningar just nu");
    this.ordersLabel = SiteConfig.getLabel("RESTAURANT_ORDERS", "beställningar");

    this.today = createDate();
    this._isMounted = true;
    this.foodTerminalId = extract(props, "foodTerminalId");

    this.state = {
      //     openingHoursFetched: false,
      //     openingHours: null
    };
  }

  componentDidMount() {
    if (!this.id || !this._isMounted) {
      return;
    }

    /* OpeningHoursStore.getRestaurantByIdAndDate(this.id, this.today).then( response => {
            const openingHours = response && response.open ? response.open + " - " + response.close : this.closedLabel;

            this.setState({
                openingHours: openingHours,
                openingHoursFetched: true
            });

        }).catch( error => {
            console.error(error);
            this.setState({
                openingHoursFetched: true
            })
        }) */

    if (this.foodTerminalId) {
      this.fetchQueueStatus(this.foodTerminalId);
      this.fetchQueueStatusInterval = setInterval(() => this.fetchQueueStatus(this.foodTerminalId), 10000);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.fetchQueueStatusInterval);
  }

  fetchQueueStatus(terminalId) {
    ParkFoodService.getQueueStatusForWeb(terminalId)
      .then((response) => {
        const readyToCollectOrders = extract(response, "[0].readyForDeliveryOrders", []);
        const ordersBeingPrepared = extract(response, "[0].preparingOrders", []);

        this.setState({
          readyToCollectOrders: readyToCollectOrders,
          numbersPreparing: ordersBeingPrepared,
          ordersLoading: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ ordersLoading: false });
      });
  }

  renderOrderNumberList(numbersArray, orderNumbersClass) {
    if (!isArray(numbersArray)) {
      return <p className={styles.noOrdersToShow}>{this.noOrdersToShowLabel}</p>;
    }

    return (
      <ul className={styles.numberList}>
        <AnimatePresence>
          {numbersArray.map((number) => (
            <motion.li
              key={number}
              layout={true}
              initial={{ x: -150, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <FoodNumber className={orderNumbersClass} number={number} />
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
    );
  }

  render() {
    return (
      <section
        className={[`block block--with-utility`, styles.restaurantBlock].join(" ")}
        data-contentful-id={this.props.contentful_id}
      >
        <div className={["block--max-width", styles.outerWrapper].join(" ")}>
          <UtilityArea
            visible={this.externalPejLink ? true : false}
            className={styles.utilityArea}
            buttonLink={this.externalPejLink}
            buttonLabel={this.utilityAreaLabel}
          />
          <div className={["block--padded", styles.contentWrapper].join(" ")}>
            {this.title && <h1 className={[styles.title, "text--with-shadow"].join(" ")}>{this.title}</h1>}
            {this.preamble && <div className={["preamble text--with-shadow"].join(" ")}>{this.preamble}</div>}
            {this.description && (
              <div
                className={[styles.description, "text--with-shadow"].join(" ")}
                dangerouslySetInnerHTML={{ __html: this.description }}
              />
            )}
            {this.foodTerminalId && (
              <div className={styles.foodOrderWrapper}>
                <div id="order-queue" />
                <h3>{this.foodOdersLabel}</h3>
                <div className={styles.foodTerminalWrapper}>
                  <h5 className={styles.readyForPickupHeadline}>{this.readyToCollectLabel}</h5>
                  {this.state.ordersLoading ? (
                    <p className={styles.loadingLabel}>{this.fetchingOrdersLabel}</p>
                  ) : (
                    this.renderOrderNumberList(this.state.readyToCollectOrders, styles.readyToCollectNumber)
                  )}
                  <h5 className={styles.numbersWaitingHeadline}>
                    {`${this.rightNowPreparedLabel} ${
                      isArray(this.state.numbersPreparing) ? this.state.numbersPreparing.length : 0
                    } ${this.ordersLabel}`}
                  </h5>
                  {this.state.ordersLoading ? (
                    <p className={styles.loadingLabel}>{this.fetchingOrdersLabel}</p>
                  ) : (
                    this.renderOrderNumberList(this.state.numbersPreparing, styles.preparingNumber)
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

export const fragmentRestaurantBlock = graphql`
  fragment RestaurantBlock on ContentfulRestaurantBlock {
    contentful_id
    id
    sortIndex
    title
    preamble {
      preamble
    }
    description {
      childMarkdownRemark {
        html
      }
    }
    shortDescriptionInList
    imageInList {
      ...Asset
      description
      gatsbyImageData(width: 312, height: 224, layout: CONSTRAINED, quality: 100, resizingBehavior: FILL)
    }
    label
    pageLink {
      slug
    }
    # We create an alias here because of inconsistent naming between Contentful environments. Core expects restaurantPageLink.
    restaurantPageLink: pageLink {
      slug
    }
    tags {
      id
      title
    }
    mapLink {
      ...Link
    }
    externalPejLink
    foodTerminalId
  }
`;
